// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/submission_management_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { JepxSpotPortion, PlanConsistencyStatus, PlanSourceType } from "../../bfftypes/v1/plan_submission_pb";
import { file_bfftypes_v1_plan_submission } from "../../bfftypes/v1/plan_submission_pb";
import type { PlanSlot } from "./procurement_plan_model_pb";
import { file_bffuser_v1_procurement_plan_model } from "./procurement_plan_model_pb";
import type { PlanCounterpartyMismatchPartner, PlanCounterpartyMismatchResolution, PlanHandlingMemo, ResolvePlanCounterpartyMismatchResult, SubmissionDashboardArea, SubmissionManagementPlanKey } from "./submission_management_model_pb";
import { file_bffuser_v1_submission_management_model } from "./submission_management_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Date } from "../../google/type/date_pb";
import { file_google_type_date } from "../../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/submission_management_service.proto.
 */
export const file_bffuser_v1_submission_management_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_bfftypes_v1_area, file_bfftypes_v1_plan_submission, file_bffuser_v1_procurement_plan_model, file_bffuser_v1_submission_management_model, file_buf_validate_validate, file_google_type_date]);

/**
 * @generated from message bffuser.v1.GetSubmissionDashboardRequest
 */
export type GetSubmissionDashboardRequest = Message<"bffuser.v1.GetSubmissionDashboardRequest"> & {
  /**
   * Target date (当日 / 翌日 resolved by the frontend from server time).
   *
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;
};

/**
 * Describes the message bffuser.v1.GetSubmissionDashboardRequest.
 * Use `create(GetSubmissionDashboardRequestSchema)` to create a new message.
 */
export const GetSubmissionDashboardRequestSchema: GenMessage<GetSubmissionDashboardRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 0);

/**
 * @generated from message bffuser.v1.GetSubmissionDashboardResponse
 */
export type GetSubmissionDashboardResponse = Message<"bffuser.v1.GetSubmissionDashboardResponse"> & {
  /**
   * Evaluated value of the submission-management feature flag, one value
   * shared by every organization (false on evaluation failure).
   *
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;

  /**
   * Empty when feature_enabled is false. Order is not guaranteed; the
   * frontend orders areas by docs/specs/conventions.md.
   *
   * @generated from field: repeated bffuser.v1.SubmissionDashboardArea areas = 2;
   */
  areas: SubmissionDashboardArea[];
};

/**
 * Describes the message bffuser.v1.GetSubmissionDashboardResponse.
 * Use `create(GetSubmissionDashboardResponseSchema)` to create a new message.
 */
export const GetSubmissionDashboardResponseSchema: GenMessage<GetSubmissionDashboardResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 1);

/**
 * @generated from message bffuser.v1.GetPlanCounterpartyMismatchRequest
 */
export type GetPlanCounterpartyMismatchRequest = Message<"bffuser.v1.GetPlanCounterpartyMismatchRequest"> & {
  /**
   * Any version of the plan (the plan detail screen's id). Empty when
   * plan_key names the plan.
   *
   * @generated from field: string plan_submission_id = 1;
   */
  planSubmissionId: string;

  /**
   * The plan's business key, for a plan that may have no plan submission
   * (AC-PSM-078: a plan shown from an inconsistency notice with no matching
   * version). Unset when plan_submission_id names the plan. NOT_FOUND when
   * the key has neither a version nor a displayed unmatched notice.
   *
   * @generated from field: bffuser.v1.SubmissionManagementPlanKey plan_key = 2;
   */
  planKey?: SubmissionManagementPlanKey;
};

/**
 * Describes the message bffuser.v1.GetPlanCounterpartyMismatchRequest.
 * Use `create(GetPlanCounterpartyMismatchRequestSchema)` to create a new message.
 */
export const GetPlanCounterpartyMismatchRequestSchema: GenMessage<GetPlanCounterpartyMismatchRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 2);

/**
 * @generated from message bffuser.v1.GetPlanCounterpartyMismatchResponse
 */
export type GetPlanCounterpartyMismatchResponse = Message<"bffuser.v1.GetPlanCounterpartyMismatchResponse"> & {
  /**
   * Evaluated value of the submission-management feature flag for the
   * current organization (false on evaluation failure). Every other field is
   * empty when false.
   *
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;

  /**
   * The plan has an unresolved counterparty mismatch (AC-PSM-063).
   *
   * @generated from field: bool has_unresolved = 2;
   */
  hasUnresolved: boolean;

  /**
   * Counterparties of the unresolved mismatch; procurement side first, each
   * side by counterparty code. Empty when has_unresolved is false.
   *
   * @generated from field: repeated bffuser.v1.PlanCounterpartyMismatchPartner partners = 3;
   */
  partners: PlanCounterpartyMismatchPartner[];

  /**
   * Opaque token to pass to ResolvePlanCounterpartyMismatch. Empty when
   * has_unresolved is false.
   *
   * @generated from field: string resolution_token = 4;
   */
  resolutionToken: string;

  /**
   * The plan's last resolution, absent when it was never resolved.
   *
   * @generated from field: optional bffuser.v1.PlanCounterpartyMismatchResolution resolution = 5;
   */
  resolution?: PlanCounterpartyMismatchResolution;

  /**
   * The plan shows an unmatched inconsistency notice (AC-PSM-078: OCCTO holds
   * a plan with no eBalance submission record) while the screen shows one of
   * its versions: the version detail shows the AC-PPD-029 guidance. Independent
   * of has_unresolved (stays true after the mismatch is resolved). False when
   * feature_enabled is false.
   *
   * @generated from field: bool shows_no_submission_record_notice = 6;
   */
  showsNoSubmissionRecordNotice: boolean;

  /**
   * The plan's 整合ステータス (plan-common.md AC-IC-004), judged like the plan
   * list row except that a plan showing AC-PSM-078 judges its counterparty
   * mismatch from its AC-PSM-078 notices (procurement-plan-detail.md
   * AC-PPD-028 / 029). UNSPECIFIED when feature_enabled is false: show no
   * badge then (never 整合).
   *
   * @generated from field: bfftypes.v1.PlanConsistencyStatus consistency_status = 7;
   */
  consistencyStatus: PlanConsistencyStatus;
};

/**
 * Describes the message bffuser.v1.GetPlanCounterpartyMismatchResponse.
 * Use `create(GetPlanCounterpartyMismatchResponseSchema)` to create a new message.
 */
export const GetPlanCounterpartyMismatchResponseSchema: GenMessage<GetPlanCounterpartyMismatchResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 3);

/**
 * @generated from message bffuser.v1.ResolvePlanCounterpartyMismatchRequest
 */
export type ResolvePlanCounterpartyMismatchRequest = Message<"bffuser.v1.ResolvePlanCounterpartyMismatchRequest"> & {
  /**
   * Any version of the plan. Empty when plan_key names the plan.
   *
   * @generated from field: string plan_submission_id = 1;
   */
  planSubmissionId: string;

  /**
   * resolution_token of the GetPlanCounterpartyMismatch shown in the dialog.
   * Opaque to the client; its form (64 lowercase hex characters) is checked.
   *
   * @generated from field: string resolution_token = 2;
   */
  resolutionToken: string;

  /**
   * The plan's business key, for a plan that may have no plan submission
   * (AC-PSM-078: a plan shown from an inconsistency notice with no matching
   * version). Unset when plan_submission_id names the plan. NOT_FOUND when
   * the key has neither a version nor a displayed unmatched notice.
   *
   * @generated from field: bffuser.v1.SubmissionManagementPlanKey plan_key = 3;
   */
  planKey?: SubmissionManagementPlanKey;
};

/**
 * Describes the message bffuser.v1.ResolvePlanCounterpartyMismatchRequest.
 * Use `create(ResolvePlanCounterpartyMismatchRequestSchema)` to create a new message.
 */
export const ResolvePlanCounterpartyMismatchRequestSchema: GenMessage<ResolvePlanCounterpartyMismatchRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 4);

/**
 * @generated from message bffuser.v1.ResolvePlanCounterpartyMismatchResponse
 */
export type ResolvePlanCounterpartyMismatchResponse = Message<"bffuser.v1.ResolvePlanCounterpartyMismatchResponse"> & {
  /**
   * @generated from field: bffuser.v1.ResolvePlanCounterpartyMismatchResult result = 1;
   */
  result: ResolvePlanCounterpartyMismatchResult;
};

/**
 * Describes the message bffuser.v1.ResolvePlanCounterpartyMismatchResponse.
 * Use `create(ResolvePlanCounterpartyMismatchResponseSchema)` to create a new message.
 */
export const ResolvePlanCounterpartyMismatchResponseSchema: GenMessage<ResolvePlanCounterpartyMismatchResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 5);

/**
 * @generated from message bffuser.v1.ListPlanHandlingMemosRequest
 */
export type ListPlanHandlingMemosRequest = Message<"bffuser.v1.ListPlanHandlingMemosRequest"> & {
  /**
   * Any version of the plan (the plan detail screen's id). Empty when
   * plan_key names the plan.
   *
   * @generated from field: string plan_submission_id = 1;
   */
  planSubmissionId: string;

  /**
   * The plan's business key, for a plan that may have no plan submission
   * (AC-PSM-078: a plan shown from an inconsistency notice with no matching
   * version). Unset when plan_submission_id names the plan. NOT_FOUND when
   * the key has neither a version nor a displayed unmatched notice.
   *
   * @generated from field: bffuser.v1.SubmissionManagementPlanKey plan_key = 2;
   */
  planKey?: SubmissionManagementPlanKey;
};

/**
 * Describes the message bffuser.v1.ListPlanHandlingMemosRequest.
 * Use `create(ListPlanHandlingMemosRequestSchema)` to create a new message.
 */
export const ListPlanHandlingMemosRequestSchema: GenMessage<ListPlanHandlingMemosRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 6);

/**
 * @generated from message bffuser.v1.ListPlanHandlingMemosResponse
 */
export type ListPlanHandlingMemosResponse = Message<"bffuser.v1.ListPlanHandlingMemosResponse"> & {
  /**
   * Evaluated value of the submission-management feature flag (false on
   * evaluation failure). memos is empty when false.
   *
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;

  /**
   * posted_at ascending, then id ascending.
   *
   * @generated from field: repeated bffuser.v1.PlanHandlingMemo memos = 2;
   */
  memos: PlanHandlingMemo[];
};

/**
 * Describes the message bffuser.v1.ListPlanHandlingMemosResponse.
 * Use `create(ListPlanHandlingMemosResponseSchema)` to create a new message.
 */
export const ListPlanHandlingMemosResponseSchema: GenMessage<ListPlanHandlingMemosResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 7);

/**
 * @generated from message bffuser.v1.RecordPlanHandlingMemoRequest
 */
export type RecordPlanHandlingMemoRequest = Message<"bffuser.v1.RecordPlanHandlingMemoRequest"> & {
  /**
   * Any version of the plan (the plan detail screen's id). Empty when
   * plan_key names the plan.
   *
   * @generated from field: string plan_submission_id = 1;
   */
  planSubmissionId: string;

  /**
   * Client-generated memo id: regenerate it whenever the body changes and
   * after a successful record, keep it for a retry of the same body.
   *
   * @generated from field: string memo_id = 2;
   */
  memoId: string;

  /**
   * The business rule (after trimming the surrounding white space:
   * non-empty, <= 100 code points, no NUL) is checked by the backend; this rule
   * only bounds the raw value.
   *
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * The plan's business key, for a plan that may have no plan submission
   * (AC-PSM-078: a plan shown from an inconsistency notice with no matching
   * version). Unset when plan_submission_id names the plan. NOT_FOUND when
   * the key has neither a version nor a displayed unmatched notice.
   *
   * @generated from field: bffuser.v1.SubmissionManagementPlanKey plan_key = 4;
   */
  planKey?: SubmissionManagementPlanKey;
};

/**
 * Describes the message bffuser.v1.RecordPlanHandlingMemoRequest.
 * Use `create(RecordPlanHandlingMemoRequestSchema)` to create a new message.
 */
export const RecordPlanHandlingMemoRequestSchema: GenMessage<RecordPlanHandlingMemoRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 8);

/**
 * @generated from message bffuser.v1.RecordPlanHandlingMemoResponse
 */
export type RecordPlanHandlingMemoResponse = Message<"bffuser.v1.RecordPlanHandlingMemoResponse"> & {
  /**
   * The stored memo (the earlier one on a retry).
   *
   * @generated from field: bffuser.v1.PlanHandlingMemo memo = 1;
   */
  memo?: PlanHandlingMemo;
};

/**
 * Describes the message bffuser.v1.RecordPlanHandlingMemoResponse.
 * Use `create(RecordPlanHandlingMemoResponseSchema)` to create a new message.
 */
export const RecordPlanHandlingMemoResponseSchema: GenMessage<RecordPlanHandlingMemoResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 9);

/**
 * @generated from message bffuser.v1.GetNoSubmissionRecordPlanRequest
 */
export type GetNoSubmissionRecordPlanRequest = Message<"bffuser.v1.GetNoSubmissionRecordPlanRequest"> & {
  /**
   * The plan's business key.
   *
   * @generated from field: bffuser.v1.SubmissionManagementPlanKey plan_key = 1;
   */
  planKey?: SubmissionManagementPlanKey;
};

/**
 * Describes the message bffuser.v1.GetNoSubmissionRecordPlanRequest.
 * Use `create(GetNoSubmissionRecordPlanRequestSchema)` to create a new message.
 */
export const GetNoSubmissionRecordPlanRequestSchema: GenMessage<GetNoSubmissionRecordPlanRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 10);

/**
 * @generated from message bffuser.v1.GetNoSubmissionRecordPlanResponse
 */
export type GetNoSubmissionRecordPlanResponse = Message<"bffuser.v1.GetNoSubmissionRecordPlanResponse"> & {
  /**
   * Evaluated value of the submission-management feature flag (false on
   * evaluation failure). result is unset when false.
   *
   * @generated from field: bool feature_enabled = 1;
   */
  featureEnabled: boolean;

  /**
   * @generated from oneof bffuser.v1.GetNoSubmissionRecordPlanResponse.result
   */
  result: {
    /**
     * The plan has no representative version and shows an unmatched notice
     * (AC-PPD-028).
     *
     * @generated from field: bffuser.v1.NoSubmissionRecordPlan plan = 2;
     */
    value: NoSubmissionRecordPlan;
    case: "plan";
  } | {
    /**
     * The plan's representative version (the one the 取引先カード links to);
     * open its detail instead (AC-PPD-029).
     *
     * @generated from field: string plan_submission_id = 3;
     */
    value: string;
    case: "planSubmissionId";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message bffuser.v1.GetNoSubmissionRecordPlanResponse.
 * Use `create(GetNoSubmissionRecordPlanResponseSchema)` to create a new message.
 */
export const GetNoSubmissionRecordPlanResponseSchema: GenMessage<GetNoSubmissionRecordPlanResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 11);

/**
 * NoSubmissionRecordPlan is a plan OCCTO holds with no eBalance submission
 * record, built from the adopted unmatched inconsistency notice (AC-PPD-028).
 * The notice carries no demand, so there is no demand row.
 *
 * @generated from message bffuser.v1.NoSubmissionRecordPlan
 */
export type NoSubmissionRecordPlan = Message<"bffuser.v1.NoSubmissionRecordPlan"> & {
  /**
   * 対象日 (JP06171).
   *
   * @generated from field: google.type.Date target_date = 1;
   */
  targetDate?: Date;

  /**
   * The trailing digit of submission_entity_code.
   *
   * @generated from field: bfftypes.v1.AreaCode area_code = 2;
   */
  areaCode: AreaCode;

  /**
   * 計画提出者コード (JP06360).
   *
   * @generated from field: string submission_entity_code = 3;
   */
  submissionEntityCode: string;

  /**
   * 取引先別調達 rows (M16/M17) in notice order. Several rows may share a
   * counterparty code (one per contract); the caller aggregates them.
   *
   * @generated from field: repeated bffuser.v1.NoSubmissionRecordPlanRow procurement_rows = 4;
   */
  procurementRows: NoSubmissionRecordPlanRow[];

  /**
   * 取引先別販売 rows (M20/M21) with the 販売量（確定） (JP06319) values only.
   *
   * @generated from field: repeated bffuser.v1.NoSubmissionRecordPlanRow sales_rows = 5;
   */
  salesRows: NoSubmissionRecordPlanRow[];
};

/**
 * Describes the message bffuser.v1.NoSubmissionRecordPlan.
 * Use `create(NoSubmissionRecordPlanSchema)` to create a new message.
 */
export const NoSubmissionRecordPlanSchema: GenMessage<NoSubmissionRecordPlan> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 12);

/**
 * NoSubmissionRecordPlanRow is one counterparty row of an inconsistency
 * notice.
 *
 * @generated from message bffuser.v1.NoSubmissionRecordPlanRow
 */
export type NoSubmissionRecordPlanRow = Message<"bffuser.v1.NoSubmissionRecordPlanRow"> & {
  /**
   * 取引先コード (JP06366 取引先BGコード).
   *
   * @generated from field: string counterparty_code = 1;
   */
  counterpartyCode: string;

  /**
   * Trading-partner master short name; "—" when the code is ambiguous or not
   * in the master (the notice's own name is never used).
   *
   * @generated from field: optional string counterparty_name = 2;
   */
  counterpartyName?: string;

  /**
   * BG_BILATERAL, or JEPX_SPOT / JEPX_INTRADAY for the JEPX preset codes.
   *
   * @generated from field: bfftypes.v1.PlanSourceType source_type = 3;
   */
  sourceType: PlanSourceType;

  /**
   * JEPX スポット 調達 rows only: 調達先未定分 / 相対契約分 from the row name
   * (JP06367).
   *
   * @generated from field: optional bfftypes.v1.JepxSpotPortion jepx_spot_portion = 4;
   */
  jepxSpotPortion?: JepxSpotPortion;

  /**
   * 48 slots, koma 1 first. A koma the notice has no value for is absent.
   *
   * @generated from field: repeated bffuser.v1.PlanSlot slots = 5;
   */
  slots: PlanSlot[];
};

/**
 * Describes the message bffuser.v1.NoSubmissionRecordPlanRow.
 * Use `create(NoSubmissionRecordPlanRowSchema)` to create a new message.
 */
export const NoSubmissionRecordPlanRowSchema: GenMessage<NoSubmissionRecordPlanRow> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_submission_management_service, 13);

/**
 * SubmissionManagementService provides Connect RPCs for the 提出管理
 * (submission management) dashboard
 * (docs/specs/plan-submit/submission-management.md).
 *
 * The feature flag is evaluated by the backend; the BFF only forwards its
 * result.
 *
 * @generated from service bffuser.v1.SubmissionManagementService
 */
export const SubmissionManagementService: GenService<{
  /**
   * GetSubmissionDashboard returns, for the target date, every area that has
   * a demand-procurement plan record registered and the plan-type cards
   * valid in that area on that date. When feature_enabled is false the
   * frontend shows the under-development placeholder and areas is empty.
   *
   * @generated from rpc bffuser.v1.SubmissionManagementService.GetSubmissionDashboard
   */
  getSubmissionDashboard: {
    methodKind: "unary";
    input: typeof GetSubmissionDashboardRequestSchema;
    output: typeof GetSubmissionDashboardResponseSchema;
  },
  /**
   * GetPlanCounterpartyMismatch returns, for the plan the given plan
   * submission version belongs to, whether it has an unresolved
   * counterparty mismatch (show the 「取引相手間不整合解消」 button only when
   * has_unresolved), the counterparties for the confirmation dialog, and the
   * token ResolvePlanCounterpartyMismatch must echo. When feature_enabled is
   * false the button is not shown.
   *
   * @generated from rpc bffuser.v1.SubmissionManagementService.GetPlanCounterpartyMismatch
   */
  getPlanCounterpartyMismatch: {
    methodKind: "unary";
    input: typeof GetPlanCounterpartyMismatchRequestSchema;
    output: typeof GetPlanCounterpartyMismatchResponseSchema;
  },
  /**
   * ResolvePlanCounterpartyMismatch records the plan's unresolved
   * counterparty mismatches as resolved by the current member. STALE means
   * nothing was recorded because the list changed: re-read and show the
   * latest list. Never retried automatically (docs/specs/conventions.md).
   *
   * @generated from rpc bffuser.v1.SubmissionManagementService.ResolvePlanCounterpartyMismatch
   */
  resolvePlanCounterpartyMismatch: {
    methodKind: "unary";
    input: typeof ResolvePlanCounterpartyMismatchRequestSchema;
    output: typeof ResolvePlanCounterpartyMismatchResponseSchema;
  },
  /**
   * ListPlanHandlingMemos returns the 対応メモ history of the plan the given
   * plan submission version belongs to (AC-PSM-068), posted_at ascending
   * then id ascending. When feature_enabled is false the panel is not shown.
   * NOT_FOUND when the plan submission does not exist in the current
   * organization (flag on).
   *
   * @generated from rpc bffuser.v1.SubmissionManagementService.ListPlanHandlingMemos
   */
  listPlanHandlingMemos: {
    methodKind: "unary";
    input: typeof ListPlanHandlingMemosRequestSchema;
    output: typeof ListPlanHandlingMemosResponseSchema;
  },
  /**
   * RecordPlanHandlingMemo appends a 対応メモ posted by the current member
   * (AC-PSM-057). It never resolves the counterparty mismatch (AC-PSM-058).
   * INVALID_ARGUMENT (no ErrorInfo) when the body is empty after trimming
   * the surrounding white space, longer than 100 code points or contains
   * NUL, or memo_id
   * is the nil UUID. FAILED_PRECONDITION when the flag is off; NOT_FOUND
   * when the plan submission does not exist in the current organization;
   * ALREADY_EXISTS when memo_id is stored with another plan, body or
   * poster. Never retried automatically (docs/specs/conventions.md); a
   * manual retry resends the same memo_id. There is no update or delete RPC
   * (AC-PSM-061).
   *
   * @generated from rpc bffuser.v1.SubmissionManagementService.RecordPlanHandlingMemo
   */
  recordPlanHandlingMemo: {
    methodKind: "unary";
    input: typeof RecordPlanHandlingMemoRequestSchema;
    output: typeof RecordPlanHandlingMemoResponseSchema;
  },
  /**
   * GetNoSubmissionRecordPlan returns the plan the business key names when it
   * has no eBalance version and shows an unmatched inconsistency notice
   * (AC-PSM-078): the counterparty × 48-koma values OCCTO holds, taken from
   * the adopted (latest) notice, for the read-only plan detail
   * (procurement-plan-detail.md AC-PPD-028). When the key's plan has a
   * representative version (the one the 取引先カード links to) it returns that
   * version's id instead, so the caller opens the version detail
   * (AC-PPD-029). When feature_enabled is false no result is set.
   * NOT_FOUND when the key has neither a version nor a displayed unmatched
   * notice in the current organization; INTERNAL when the adopted notice
   * cannot be shown as a table (a non-integer value, or a JEPX スポット 調達
   * row whose name maps to no portion).
   *
   * @generated from rpc bffuser.v1.SubmissionManagementService.GetNoSubmissionRecordPlan
   */
  getNoSubmissionRecordPlan: {
    methodKind: "unary";
    input: typeof GetNoSubmissionRecordPlanRequestSchema;
    output: typeof GetNoSubmissionRecordPlanResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_submission_management_service, 0);

